<template>
  <div class="table-container">
    <table class="table is-fullwidth is-narrow is-hoverable">
      <thead>
        <tr class="is-unselectable">
          <th @click="$emit('order', 'name')">Name</th>
          <th @click="$emit('order', 'version')">High capability</th>
          <th @click="$emit('order', 'shared')">Owner</th>
          <th @click="$emit('order', 'permission')">Permissions</th>
        </tr>
      </thead>
      <TableEffect>
        <tr v-for="source of items" :key="source.uid">
          <td>
            <div
              @contextmenu.prevent="
                $emit('menu', { e: $event, source: source })
              "
            >
              <router-link v-if="!source.edit" :to="`/repos/${source.uid}`">
                <span class="icon is-small margin-right-5">
                  <i class="mdi mdi-database" aria-hidden="true"></i>
                </span>
                <span>{{ source.name }}</span>
              </router-link>
              <EditSingleField
                v-if="source.edit"
                :text="source.name"
                validation="required"
                type="text"
                name="name"
                @save="$emit('save', { source: source, text: $event })"
                @cancel="$emit('cancel', source)"
                :isLoading="source.saving"
              ></EditSingleField>
            </div>
          </td>
          <td>
            {{ !source.external && source.version >= 2 ? "Yes" : "No" }}
          </td>
          <td>{{ source.shared ? "No" : "Yes" }}</td>
          <td>{{ permission(source) }}</td>
        </tr>
      </TableEffect>
    </table>
  </div>
</template>

<script>
import permissions from "@/utils/permission.js";

export default {
  components: {
    TableEffect: () => import("@/components/singles/TableEffect.vue"),
    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  props: { items: Array },
  computed: {
    permission() {
      return (source) => {
        if (source.permission) return permissions.source[source.permission];
        else return "Owner";
      };
    },
  },
};
</script>
